
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'checkbox-field',
  imports: [],
  templateUrl: './checkbox-field.component.html',
  styleUrl: './checkbox-field.component.scss'
})
export class CheckboxFieldComponent implements OnInit, OnChanges {
  @Input() label?: string;
  @Input() options: { key: string, value: string }[] = [];
  @Input() selectedValues: string[] = [];
  @Input() readonly: boolean = false;
  @Input() hasError: boolean = false;
  @Output() selectedValuesChange = new EventEmitter<string[]>();

  ngOnInit(): void {

    
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedValues'] && changes['selectedValues'].currentValue) {
      this.isChecked(changes['selectedValues'].currentValue);
    }
    if (changes['readonly'] && changes['readonly'].currentValue) {
      this.readonly = changes['readonly'].currentValue
    }
  }
  isChecked(key: string): boolean {
    return this.selectedValues?.includes(key);
  }

  onCheckboxChange(event: Event, key: string): void {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.selectedValues = [...this.selectedValues, key];
    } else {
      this.selectedValues = this.selectedValues.filter(value => value !== key);
    }
    this.selectedValuesChange.emit(this.selectedValues);
  }
}
